import { useEffect } from 'react';
import { useStore } from '../store/useStore';
import { watchAuth, toAuthUser, completeEmailLinkIfPresent } from '../lib/auth';
import { startSync, stopSync } from '../lib/sync';

/**
 * Wires Firebase Auth state into the store and drives the sync engine:
 * sign in → claim local docs + start two-way sync; sign out → local-only.
 * Also completes an email magic-link sign-in when the app opens from one.
 */
export function useAuthSync(): void {
  useEffect(() => {
    void completeEmailLinkIfPresent().catch(() => {});
    const unsub = watchAuth((u) => {
      const au = toAuthUser(u);
      const store = useStore.getState();
      store.setUser(au);
      store.setAuthReady(true);
      if (au) void startSync(au.uid);
      else stopSync();
    });
    return () => unsub();
  }, []);
}
